import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Solutions from './components/Solutions';
import Differentials from './components/Differentials';
import SocialProof from './components/SocialProof';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import InvestorView from './components/InvestorView';

const App: React.FC = () => {
  const [view, setView] = useState<'home' | 'investor'>('home');

  // Rola para o topo ao trocar de view
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [view]);

  return (
    <div className="relative overflow-x-hidden">
      <Navbar onNavigate={(v) => setView(v)} currentView={view} />
      <main>
        {view === 'home' ? (
          <>
            <Hero onInvestorClick={() => setView('investor')} />
            <Solutions />
            <Differentials />
            <ContactForm />
            <SocialProof />
            <About />
          </>
        ) : (
          <InvestorView />
        )}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default App;